
import React from 'react';
import { PopupContent } from '@/types/popup-system';
import { Windows95Popup } from './styles/Windows95Popup';
import { TerminalPopup } from './styles/TerminalPopup';
import { AnalogHorrorPopup } from './styles/AnalogHorrorPopup';
import { CosmicHorrorPopup } from './styles/CosmicHorrorPopup';
import { LiminalHorrorPopup } from './styles/LiminalHorrorPopup';
import { ClassifiedDocumentPopup } from './styles/ClassifiedDocumentPopup';
import { CorruptedTransmissionPopup } from './styles/CorruptedTransmissionPopup';

interface PopupRendererProps {
  content: PopupContent;
  onDismiss: () => void;
  onAction?: (action: string) => void;
}

export const PopupRenderer = ({ content, onDismiss, onAction }: PopupRendererProps) => {
  switch (content.style) {
    case 'windows95':
      return <Windows95Popup content={content} onDismiss={onDismiss} onAction={onAction} />;
    case 'terminal':
      return <TerminalPopup content={content} onDismiss={onDismiss} onAction={onAction} />;
    case 'analog-horror':
      return <AnalogHorrorPopup content={content} onDismiss={onDismiss} onAction={onAction} />;
    case 'cosmic-horror':
      return <CosmicHorrorPopup content={content} onDismiss={onDismiss} onAction={onAction} />;
    case 'liminal-horror':
      return <LiminalHorrorPopup content={content} onDismiss={onDismiss} onAction={onAction} />;
    case 'classified-document':
      return <ClassifiedDocumentPopup content={content} onDismiss={onDismiss} onAction={onAction} />;
    case 'corrupted-transmission':
      return <CorruptedTransmissionPopup content={content} onDismiss={onDismiss} onAction={onAction} />;
    default:
      return <Windows95Popup content={content} onDismiss={onDismiss} onAction={onAction} />;
  }
};
